import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {MembershipPointsExpiryContainerModel} from '../../../../../../models/aggregates/crm/membership-points-expiry';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class MembershipPointsExpiryBackOfficeService extends BaseApiTemplateService<MembershipPointsExpiryContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-points-ctrl-acc/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL +  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-points-ctrl-acc/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-points-ctrl-acc/backoffice-ep';
    this.httpClient = http;
  }

}


